import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { CustomJobProfileTemplateResponse } from '../../../../../data-contract/job-profile-template';
import { useApplicationFetchers } from '../../../../../fetchers/use-application-fetchers';
import { companySettingsKeys } from '../../../../api/query-keys';

const isNotFoundError = (error: Error): boolean =>
    'response' in error && error.response instanceof Response && error.response.status === 404;

export const useCustomTemplate = (
    jobArchitectureId: string,
    enabled: boolean = true,
): UseQueryResult<CustomJobProfileTemplateResponse | null, Error> => {
    const { fetchCustomJobProfileTemplate } = useApplicationFetchers();

    return useQuery({
        enabled,
        queryFn: async () => {
            const result = await fetchCustomJobProfileTemplate({ jobArchitectureId });

            if (result.isOk) {
                return result.value;
            }

            if (isNotFoundError(result.error)) {
                return null;
            }

            throw result.error;
        },
        queryKey: companySettingsKeys.customJobProfileTemplate(jobArchitectureId),
        staleTime: 30_000,
        throwOnError: false,
    });
};
